export const SPRINTS_MESSAGES = {
  unauthorizedPageTitle: "Sprints: Optimize your metabolic health"
}
